<template>
  <div id="mediainfo-container">
    <el-table style="margin-bottom: 20px;" stripe :data="[eventTrackBoard]">
      <el-table-column label="累计申领" prop="addressSubmitResultSuccessCount"></el-table-column>
      <el-table-column label="累计通过" prop="verifyResultPassCount"></el-table-column>
      <el-table-column label="累计未通过" prop="verifyResultFailedCount"></el-table-column>
      <el-table-column label="累计地址已提交" prop="addressFormSubmitCount"></el-table-column>
    </el-table>
    <el-form :inline="true" :model="formInline" ref="formInline" class="demo-form-inline">
      <el-form-item label="uuid" prop="uuid">
        <el-input v-model="formInline.uuid" placeholder="uuid"></el-input>
      </el-form-item>
      <el-form-item label="openid" prop="openid">
        <el-input v-model="formInline.openid" placeholder="openid"></el-input>
      </el-form-item>
      <el-form-item label="unionid" prop="unionid">
        <el-input v-model="formInline.unionid" placeholder="unionid"></el-input>
      </el-form-item>
      <el-form-item label="事件类型" prop="eventType">
        <el-select v-model="formInline.eventType" placeholder="请选择事件类型">
          <el-option
              v-for="item in eventOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="事件时间" prop="eventTime">
        <el-date-picker
            v-model="eventTimePickers"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="手机号" prop="phone">
        <el-input v-model="formInline.phone" placeholder="手机号"></el-input>
      </el-form-item>
      <el-form-item label="收货人" prop="receiverName">
        <el-input v-model="formInline.receiverName" placeholder="收货人"></el-input>
      </el-form-item>
      <el-form-item label="收货人电话" prop="receiverPhone">
        <el-input v-model="formInline.receiverPhone" placeholder="收货人电话"></el-input>
      </el-form-item>
      <el-form-item label="活动ID" prop="activityId">
        <el-input v-model="formInline.activityId" placeholder="活动ID"></el-input>
      </el-form-item>
      <el-form-item label="渠道" prop="channel">
        <el-input v-model="formInline.channel" placeholder="渠道"></el-input>
      </el-form-item>
      <el-form-item label="分组ID" prop="groupId">
        <el-input v-model="formInline.groupId" placeholder="分组ID"></el-input>
      </el-form-item>
      <el-form-item label="结果" prop="result">
        <el-input v-model="formInline.result" placeholder="结果"></el-input>
      </el-form-item>
      <el-form-item label="错误码" prop="errorCode">
        <el-input v-model="formInline.errorCode" placeholder="错误码"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleQuery">查询</el-button>
      </el-form-item>
      <el-form-item>
        <el-button @click="resetFormInline">重置</el-button>
      </el-form-item>
      <el-form-item v-if="loginName === 'admin'">
        <el-button @click="exportData">导出</el-button>
      </el-form-item>
    </el-form>
    <el-table
        :data="eventTrackList"
        stripe
        style="width: 100%">
      <el-table-column
          prop="id"
          label="ID"
          width="80">
      </el-table-column>
      <el-table-column
          prop="uuid"
          label="uuid">
      </el-table-column>
      <el-table-column
          prop="openid"
          label="openid">
      </el-table-column>
      <el-table-column
          prop="unionid"
          label="unionid">
      </el-table-column>
      <el-table-column
          prop="eventType"
          label="事件类型">
      </el-table-column>
      <el-table-column
          prop="eventTime"
          label="事件时间">
      </el-table-column>
      <el-table-column
          prop="serverTime"
          label="服务端时间">
      </el-table-column>
      <el-table-column
          prop="phone"
          label="手机号">
        <template slot-scope="scope">
          {{ privacyString(scope.row.phone) }}
        </template>
      </el-table-column>
      <el-table-column
          prop="receiverName"
          label="收货人">
      </el-table-column>
      <el-table-column
          prop="receiverPhone"
          label="收货人电话">
        <template slot-scope="scope">
          {{ privacyString(scope.row.receiverPhone) }}
        </template>
      </el-table-column>
      <el-table-column
          prop="receiverAddress"
          label="收货地址">
      </el-table-column>
      <el-table-column
          prop="activityId"
          label="活动ID">
      </el-table-column>
      <el-table-column
          prop="channel"
          label="渠道">
      </el-table-column>
      <el-table-column
          prop="groupId"
          label="分组ID">
      </el-table-column>
      <el-table-column
          prop="result"
          label="结果">
      </el-table-column>
      <el-table-column
          prop="errorCode"
          label="错误码">
      </el-table-column>
      <el-table-column
          prop="errorMessage"
          label="错误信息">
      </el-table-column>
      <el-table-column
          prop="extraData"
          label="额外数据">
      </el-table-column>
      <el-table-column
          prop="createdAt"
          label="创建时间">
      </el-table-column>
      <el-table-column
          prop="updatedAt"
          label="更新时间">
      </el-table-column>
      <el-table-column
          label="操作"
          align="center">
        <template slot-scope="scope">
          <el-link @click="getUserInfoHopper(scope.row.openid)" type="primary"><i class="el-icon-ice-cream-round"></i>漏斗
          </el-link>
        </template>
      </el-table-column>
    </el-table>
    <div class="block">
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="formInline.current"
          :page-sizes="[10, 20, 50]"
          :page-size="10"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
      </el-pagination>
    </div>

    <el-dialog
        :title="'用户漏斗详情 - ' + this.privacyString(this.hopperOpenid)"
        :visible.sync="dialogVisible"
        width="800px"
        :before-close="handleClose"
        custom-class="funnel-dialog"
    >
      <!-- 复制收货信息按钮区域 -->
      <div class="dialog-header-actions">
        <el-button type="primary" size="small" icon="el-icon-document-copy" @click="copyShippingInfo">
          复制收货信息
        </el-button>
      </div>

      <!-- 用户档案卡片 -->
      <div class="info-card">
        <div class="card-title">用户档案</div>
        <el-table :data="profileFields" border :show-header="false" class="profile-table">
          <el-table-column prop="label" width="120"></el-table-column>
          <el-table-column prop="value">
            <template slot-scope="scope">
              <span>{{ scope.row.value }}</span>
              <el-button
                  v-if="scope.row.copyable"
                  type="text"
                  icon="el-icon-document-copy"
                  class="copy-btn"
                  @click="copyText(scope.row.rawValue || scope.row.value)"
              ></el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 行为时间轴卡片 -->
      <div class="info-card">
        <div class="card-title">行为时间轴</div>
        <el-table :data="timelineData" border class="timeline-table">
          <!--          <el-table-column prop="status" label="状态" width="80">-->
          <!--            <template slot-scope="scope">-->
          <!--            <span :class="scope.row.status === '❌' ? 'fail-icon' : 'success-icon'">-->
          <!--              {{ scope.row.status }}-->
          <!--            </span>-->
          <!--            </template>-->
          <!--          </el-table-column>-->
          <el-table-column prop="eventType" label="行为"></el-table-column>
          <el-table-column prop="eventTime" label="时间"></el-table-column>
          <el-table-column prop="prevTime" label="耗时">
            <template slot-scope="scope">
              <span v-if="scope.row.prevTime !== 'null' && scope.row.prevTime !== '0s'"
                    class="duration-text">{{ scope.row.prevTime }}</span>
              <span v-else>—</span>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 异常信息 -->
      <!--      <div class="exception-info">-->
      <!--        <span class="exception-label">异常信息：</span>-->
      <!--        <span class="exception-content">无</span>-->
      <!--      </div>-->

      <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">关 闭</el-button>
    </span>
    </el-dialog>


  </div>
</template>

<script>
import {exportExcel, getBoard, getList, getOpenidInfoHopper} from "@/api/eventTrack";

export default {
  data() {
    return {
      loginName: localStorage.getItem('username'),
      eventTrackBoard: {},
      hopperOpenid: undefined,
      dialogVisible: false,
      profileFields: [],
      timelineData: [
        {status: '✅', action: '进入活动页', time: '06-07 14:20:11', duration: null},
        {status: '✅', action: '提交手机号', time: '06-07 14:21:23', duration: '+72s'},
        {status: '✅', action: '验新通过', time: '06-07 14:21:25', duration: '+2s'},
        {status: '✅', action: '提交地址', time: '06-07 14:22:30', duration: '+65s'},
        {status: '✅', action: '提交成功', time: '06-07 14:22:31', duration: '+1s'},
        {status: '❌', action: '未点击"立即查看"', time: '', duration: null}
      ],
      eventOptions: [{
        value: 'page_view',
        label: '用户进入活动页'
      }, {
        value: 'apply_click',
        label: '填写手机号点击"立即申领"'
      }, {
        value: 'verify_result',
        label: '验新接口返回'
      }, {
        value: 'address_form_submit',
        label: '填写地址点击"确认提交"'
      }, {
        value: 'address_submit_result',
        label: '提交地址接口返回'
      }, {
        value: 'cross_sell_click',
        label: '提交地址成功页点击"立即查看"'
      }, {
        value: 'rejected_popup_action',
        label: '验证不通过页点击"查看更多活动"或"返回首页"'
      }],
      total: 0,
      formInline: {
        current: 1,
        size: 10,
        uuid: undefined,
        openid: undefined,
        unionid: undefined,
        phone: undefined,
        receiverName: undefined,
        receiverPhone: undefined,
        receiverAddress: undefined,
        activityId: undefined,
        channel: undefined,
        groupId: undefined,
        result: undefined,
        errorCode: undefined,
        errorMessage: undefined,
        beginEventTime: this.formatDateTime(new Date()),
        endEventTime: this.formatDateTime(new Date())
      },
      eventTimePickers: undefined,
      eventTrackList: [],
      boardTimer: null,
    }
  },
  created() {
    this.getEventBoard()
    this.initQueryEventTime()
    this.getList();
    this.startBoardAutoRefresh()
  },
  beforeDestroy() {
    this.stopBoardAutoRefresh()
  },
  methods: {
    startBoardAutoRefresh() {
      this.boardTimer = setInterval(() => {
        this.getEventBoard()
      }, 10000)
    },
    stopBoardAutoRefresh() {
      if (this.boardTimer) {
        clearInterval(this.boardTimer)
        this.boardTimer = null
      }
    },
    getEventBoard(){
      getBoard().then(res => {
        this.eventTrackBoard = res.data
      })
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
          .then(_ => {
            done()
          })
          .catch(_ => {
          })
    },
    copyText(text) {
      // 复制文本到剪贴板
      const input = document.createElement('input')
      input.value = text
      document.body.appendChild(input)
      input.select()
      document.execCommand('copy')
      document.body.removeChild(input)
      this.$message({
        message: '复制成功',
        type: 'success',
        duration: 1500
      })
    },
    copyShippingInfo() {
      // 收集收货信息
      const shippingInfo = this.profileFields
          .filter(field => ['收货人:', '收货手机:', '收货地址:'].includes(field.label))
          .map(field => `${field.label} ${field.rawValue || field.value}`)
          .join('\n')
      this.copyText(shippingInfo)
    },
    // 格式化时间为 yyyy-MM-dd HH:mm:ss
    formatDateTime(date) {
      if (!date) return undefined
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      const seconds = String(date.getSeconds()).padStart(2, '0')
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    },
    handleQuery(){
      this.formInline.current = 1
      this.getList()
    },
    getList() {
      // 判断eventTimePickers不为undifend并且等于2
      if (this.eventTimePickers && this.eventTimePickers.length === 2) {
        this.formInline.beginEventTime = this.formatDateTime(this.eventTimePickers[0])
        this.formInline.endEventTime = this.formatDateTime(this.eventTimePickers[1])
      }
      getList(this.formInline).then((res) => {
        this.eventTrackList = res.data.records
        this.total = res.data.total
      })
    },
    handleSizeChange(size) {
      this.formInline.size = size
      this.getList()
    },
    handleCurrentChange(current) {
      this.formInline.current = current
      this.getList()
    },
    resetFormInline() {
      this.$refs['formInline'].resetFields()
      this.formInline.current = 1
      this.initQueryEventTime()
      this.getList()
    },
    initQueryEventTime() {
      // 设置时间eventTimePickers为当前时间赋值两个
      let now = new Date()
      this.eventTimePickers = [new Date(now.getFullYear(), now.getMonth(), now.getDate(),0, 0, 0), new Date(now.getFullYear(), now.getMonth(), now.getDate(),23, 59, 59)]
    },
    getUserInfoHopper(openid) {
      this.dialogVisible = true
      getOpenidInfoHopper(openid).then((res) => {
        const data = res.data

        // 格式化用户档案数据
        this.hopperOpenid = data.openid
        this.profileFields = [
          {label: 'openid:', value: this.privacyString(data.openid) || '-', copyable: false},
          {label: 'uuid:', value: this.privacyString(data.uuid) || '-', copyable: true, rawValue: data.uuid},
          {label: 'unionid:', value: this.privacyString(data.unionid) || '-', copyable: false},
          {label: '渠道:', value: data.channel || '-', copyable: false},
          {label: '群:', value: data.groupId ? `${data.groupId}` : '-', copyable: false},
          {label: '申领手机:', value: this.privacyString(data.phone), copyable: true, rawValue: data.phone},
          {label: '收货人:', value: data.receiverName || '-', copyable: true, rawValue: data.receiverName},
          {
            label: '收货手机:',
            value: this.privacyString(data.receiverPhone),
            copyable: true,
            rawValue: data.receiverPhone
          },
          {
            label: '收货地址:',
            value: data.receiverAddress || '-',
            copyable: true,
            rawValue: data.receiverAddress
          }
        ]

        // 格式化行为时间轴数据
        // this.timelineData = data.eventTypeTimeTree
        // 格式化行为时间轴数据
        this.timelineData = this.formatTimelineData(data.eventTypeTimeTree || [])
      })

    },
    formatTimelineData(eventTypeTimeTree) {
      if (!eventTypeTimeTree || eventTypeTimeTree.length === 0) {
        return []
      }

      // 事件类型映射为中文描述
      const eventLabelMap = {
        'page_view': '进入活动页',
        'apply_click': '提交手机号',
        'verify_result': '验新通过',
        'address_form_submit': '提交地址',
        'address_submit_result': '提交成功',
        'cross_sell_click': '点击"立即查看"',
        'rejected_popup_action': '验证不通过操作'
      }

      // 按时间排序（从旧到新）
      // const sortedEvents = [...eventTypeTimeTree].sort((a, b) => {
      //   return new Date(a.eventTime) - new Date(b.eventTime)
      // })

      // 去重，保留每种事件的最新记录
      // const uniqueEvents = []
      // const seenTypes = new Set()
      // for (let i = sortedEvents.length - 1; i >= 0; i--) {
      //   const event = sortedEvents[i]
      //   if (!seenTypes.has(event.eventType)) {
      //     seenTypes.add(event.eventType)
      //     uniqueEvents.unshift(event)
      //   }
      // }

      // 计算耗时和状态
      return eventTypeTimeTree.map((event, index) => {
        let duration = null
        if (eventTypeTimeTree.length > 2 && index < eventTypeTimeTree.length - 1) {
          const nextTime = new Date(eventTypeTimeTree[index + 1].eventTime)
          const currTime = new Date(event.eventTime)
          const diffSeconds = Math.floor((currTime - nextTime) / 1000)
          duration = `${diffSeconds}s`
        }
        // if (index > 0) {
        //   const prevTime = new Date(eventTypeTimeTree[index - 1].eventTime)
        //   const currTime = new Date(event.eventTime)
        //   const diffSeconds = Math.floor((currTime - prevTime) / 1000)
        //   if (diffSeconds > 0) {
        //     duration = `+${diffSeconds}s`
        //   }
        // }

        // 根据事件类型判断状态（这里假设所有事件都是成功的）
        const status = '✅'

        return {
          status: status,
          eventType: eventLabelMap[event.eventType] || event.eventType,
          eventTime: event.eventTime,
          prevTime: duration
        }
      })
    },
    // 字符串进行隐私处理
    privacyString(str) {
      if (!str || str.length === 0) {
        return ''
      }
      if (str.length <= 7) {
        return str.substring(0, 3) + '***'
      }
      return str.substring(0, 3) + '****' + str.substring(7)
    },
    exportData() {
      if (this.eventTimePickers && this.eventTimePickers.length === 2) {
        this.formInline.beginEventTime = this.formatDateTime(this.eventTimePickers[0])
        this.formInline.endEventTime = this.formatDateTime(this.eventTimePickers[1])
      }

      exportExcel(this.formInline).then((res) => {
        // 从响应头中获取文件名
        const contentDisposition = res.headers['content-disposition']
        let fileName = '事件数据.xlsx'
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename\*=utf-8''(.+)/)
          if (fileNameMatch && fileNameMatch[1]) {
            fileName = decodeURIComponent(fileNameMatch[1])
          }
        }

        // 创建 blob 对象
        const blob = new Blob([res.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        })

        // 创建下载链接
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = fileName

        // 触发下载
        document.body.appendChild(link)
        link.click()

        // 清理
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)

        this.$message({
          message: '导出成功',
          type: 'success'
        })
      })
    },
  }
}
</script>
<style scoped>
#mediainfo-container {
  padding: 50px;
}

.info-card {
  margin-bottom: 24px;
}
</style>
